import React from 'react';
import { Link } from 'react-router-dom';
import LatestNewsSlideInner from "./LatestNewsSlideInner";


const LatestNewsSlider = ({dataArr, title}) => {
    const windowSmall = window.innerWidth < 500;
    const firstItem = dataArr[0];

    return (
        <div className={"caseSliderContainer latestNewsSlider"}>
            <div className='latestNewsSlider__header'>
                <h1 style={{color: "black"}}>{title}</h1>
            </div>
            <div className={`caseSlide shadow`} style={{display: "flex", flexGrow: 1, justifyContent: "space-between"}}>
                <LatestNewsSlideInner
                    windowSmall={windowSmall}
                    title={firstItem.title}
                    description={firstItem.description}
                    buttonText={firstItem.buttonText}
                    buttonAction={firstItem.buttonAction}
                    caseSlideImg={firstItem.caseSlideImg}
                    date={firstItem.date}
                    arrLength={1}
                />
            </div>
            <div style={{textAlign: "center", marginTop: "48px"}}>
                <Link to='/latest_news' className='latestNewsSlider__seeMore'>More news</Link>
            </div>
        </div>
    );
};

export default LatestNewsSlider;
